import { apiEndPoint } from "./endPoint";

export const getAllFirstDayAnswerData = async (token: string) => {
  const url = `${apiEndPoint}/getAllFirstDayAnswerData`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    // console.log("status:", response.status);
    // const text = await response.text();
    // console.log("body:", text);

    if (response.ok) {
      const responseData = await response.json();
      console.log(responseData);
      return responseData;
    } else {
      throw new Error("Failed to fetch");
    }
  } catch (err) {
    console.error("Error:", err);
    return "エラーが発生しました: ${err.message}";
  }
};
